(() => {
  'use strict';
  const targets = document.querySelectorAll('.dm-hero24, .dm-inside24, .dm-gift-panel--24, .dm-events24, .dm26-hero, .dm26-inside, .dm26-craft, .dm26-gifting, .dm26-social, .dm26-events');
  if (!targets.length) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-revealed'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.16 });
  targets.forEach((el) => io.observe(el));
})();
